/**
 * Tour config — PRODUCTION.
 *
 * Anything not listed here is OFF (false by default). Keep this file conservative:
 * a tour should only be `enabled` here after its copy + design are signed off.
 * See ../README.md.
 */

import type { TourConfig } from './types';

export const config: TourConfig = {
  // Live for real learners (ULC-3164). Set startDate/endDate to window it.
  announcements: {
    enabled: true,
    autoStart: true,
    startDate: null,
    endDate: null
  }
};
